import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  BulkDeleteButton,
  EditButton,
  Filter,
  NumberInput,
  BooleanInput,
  CreateButton,
  ExportButton,
  ArrayInput,
  SimpleFormIterator,
  BooleanField,
} from 'react-admin';
import Toolbar from '@material-ui/core/Toolbar';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';

import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import DateInput from '../../../../components/DateInput';
import exporter from '../../../../utils/exporter';
import EnumInput from '../../../../components/EnumInput';
import EnumField from '../../../../components/EnumField';
import errorModel from '../errorModel';
import objectSendModel from '../objectSendModel';
import importThirdCountryP from '../importThirdCountryP';
import SendOrderButton from './SendOrderButton';
import CheckDocs from './CheckDocs';
import importHImport from '../importHImport';
import docCheckStatus from '../docCheckStatus';
const ResourceIcon = BookmarkIcon;

const resourceToString = (x) => `#${x.id}`;

const trPrefix = `resources.${resourceConfig.name}`;

const listStyles = {};

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <importHImport.OpenButton />
    <CreateButton basePath={basePath} to={`${basePath}/create`} />
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <CheckDocs {...props} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const PButton = (props) => {
  return (
    <importThirdCountryP.LinkToList
      label={`resources.${resourceConfig.name}.importThirdCountryP`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'importerCode'} />
    <EnumInput
      source={'docType'}
      translatePrefix={`${trPrefix}.enums.docType.`}
      label={`${trPrefix}.fields.docType`}
      enums={resourceConfig.enums.docType}
    />
    <TextInput source={'regNumber'} />
    <TextInput source={'docTypeCertificate'} />
    <TextInput source={'docNumberCertificate'} />
    <TextInput source={'docNumberPaper'} />
  </Filter>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    actions={<ResourceActions />}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <TextField source={'fileId'} />
      <TextField source={'importerName'} />
      <EnumField
        source={'docType'}
        translatePrefix={`${trPrefix}.enums.docType.`}
        label={`${trPrefix}.fields.docType`}
        enums={resourceConfig.enums.docType}
      />
      <TextField source={'docNumberPaper'} />
      <TextField source={'docDatePaper'} />
      <docCheckStatus.Field source={'status'} />
      <errorModel.LinkToRelatedList type={'IMPORT_THIRD_COUNTRY'} />
      <objectSendModel.LinkToRelatedList type={'IMPORT_THIRD_COUNTRY'} />
      <PButton />
      {/* <CheckButton /> */}
      <SendOrderButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.id}&quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'fileId'} />
      <DateInput source={'dateSend'} label={`resources.${resourceConfig.name}.fields.dateSend`} />
      <TextInput source={'importerName'} />
      <TextInput source={'importerCode'} />
      <TextInput source={'exportCountry'} />
      <EnumInput
        source={'docType'}
        translatePrefix={`${trPrefix}.enums.docType.`}
        label={`${trPrefix}.fields.docType`}
        enums={resourceConfig.enums.docType}
      />
      <TextInput source={'regNumber'} />
      <DateInput source={'regDate'} label={`resources.${resourceConfig.name}.fields.regDate`} />
      <NumberInput source={'decisionCode'} />
      <DateInput
        source={'decisionDate'}
        label={`resources.${resourceConfig.name}.fields.decisionDate`}
      />
      <TextInput source={'customCode'} />
      <TextInput source={'docTypeCertificate'} />
      <TextInput source={'docNumberCertificate'} />
      <DateInput
        source={'docDateCertificate'}
        label={`resources.${resourceConfig.name}.fields.docDateCertificate`}
      />
      <TextInput source={'docNumberPaper'} />
      <DateInput
        source={'docDatePaper'}
        label={`resources.${resourceConfig.name}.fields.docDatePaper`}
      />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm>
      <TextInput source={'fileId'} />
      <DateInput source={'dateSend'} label={`resources.${resourceConfig.name}.fields.dateSend`} />
      <TextInput source={'importerName'} />
      <TextInput source={'importerCode'} />
      <TextInput source={'exportCountry'} />
      <EnumInput
        source={'docType'}
        translatePrefix={`${trPrefix}.enums.docType.`}
        label={`${trPrefix}.fields.docType`}
        enums={resourceConfig.enums.docType}
      />
      <TextInput source={'regNumber'} />
      <DateInput source={'regDate'} label={`resources.${resourceConfig.name}.fields.regDate`} />
      <NumberInput source={'decisionCode'} />
      <DateInput
        source={'decisionDate'}
        label={`resources.${resourceConfig.name}.fields.decisionDate`}
      />
      <TextInput source={'customCode'} />
      <TextInput source={'docTypeCertificate'} />
      <TextInput source={'docNumberCertificate'} />
      <DateInput
        source={'docDateCertificate'}
        label={`resources.${resourceConfig.name}.fields.docDateCertificate`}
      />
      <TextInput source={'docNumberPaper'} />
      <DateInput
        source={'docDatePaper'}
        label={`resources.${resourceConfig.name}.fields.docDatePaper`}
      />
    </SimpleForm>
  </Edit>
);

const ResourceStringField = ({ record }) => <span>{resourceToString(record)}</span>;

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <ResourceStringField />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={resourceToString} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={resourceToString} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      docDatePaper: {
        type: 'date',
      },
      docDateCertificate: {
        type: 'date',
      },
      decisionDate: {
        type: 'dateTime',
      },
      regDate: {
        type: 'date',
      },
      dateSend: {
        type: 'dateTime',
      },
    },
  },
};
